import React, { useContext, useEffect, useState } from "react"
import { Div, Text } from "atomize"
import { toast } from "react-toastify"
import Container from "../atoms/Container"
import TextInput from "../inputs/TextInput"
import ConfirmButtons from "../buttons/ConfirmButtons"
import { theme } from "../settings/config"
import { callFunction } from "../services/firebase.service"
import { profileContext } from "../providers/profile.provider"

const DELETE_WORD = "ELIMINA"

// Prima di cancellare si dice cosa si sta cancellando, contato: "il circolo
// Siro con 43 allievi e 512 lezioni" pesa quanto deve pesare, mentre "sei
// sicuro?" non pesa niente. E si fa scrivere una parola, perché un bottone
// si preme per sbaglio e una parola no.
export function DeleteAccountModal({ closeModal }) {
	const { logout } = useContext(profileContext)

	const [summary, setSummary] = useState(null)
	const [confirmation, setConfirmation] = useState("")
	const [isDeleting, setIsDeleting] = useState(false)
	const [failed, setFailed] = useState(false)

	useEffect(() => {
		const summarize = callFunction("summarizeCoachAccount")
		summarize()
			.then(({ data }) => setSummary(data))
			.catch(() => setFailed(true))
	}, [])

	const handleDelete = async () => {
		setIsDeleting(true)
		try {
			const deleteAccount = callFunction("deleteCoachAccount")
			await deleteAccount({ confirm: DELETE_WORD })

			toast.info("Il tuo account è stato eliminato", { position: "top-center" })
			closeModal()
			await logout()
		} catch (err) {
			toast.error(err.message || "Non sono riuscito a eliminare l'account", {
				position: "top-center",
			})
			setIsDeleting(false)
		}
	}

	const owned = summary?.schools?.filter(school => school.isOwned) ?? []
	const shared = summary?.schools?.filter(school => !school.isOwned) ?? []

	return (
		<Container>
			<Div m={{ b: "0.25rem" }} textWeight="bold" textSize="title">
				Elimina il tuo account
			</Div>
			<Text textSize="caption" textColor={theme.colors.text_light} m={{ b: "1rem" }}>
				Non si torna indietro. Se vuoi tenerne una copia, scarica prima i tuoi dati.
			</Text>

			<Div maxH="45vh" overflow="auto">
				<Container>
					{failed && (
						<Text textSize="body" textColor={theme.colors.red}>
							Non sono riuscito a leggere cosa verrebbe eliminato. Riprova più tardi.
						</Text>
					)}

					{!summary && !failed && (
						<Text textSize="body" textColor={theme.colors.text_light}>
							Sto contando cosa verrebbe eliminato...
						</Text>
					)}

					{owned.length > 0 && (
						<Div m={{ b: "1rem" }}>
							<Text textSize="body" textWeight="bold" m={{ b: "0.5rem" }}>
								Spariranno per sempre
							</Text>
							{owned.map(school => (
								<Text
									key={school.schoolID}
									textSize="body"
									textColor={theme.colors.text_light}>
									• {school.schoolName}: {school.players}{" "}
									{school.players === 1 ? "allievo" : "allievi"} e{" "}
									{school.lessons} {school.lessons === 1 ? "lezione" : "lezioni"}
								</Text>
							))}
						</Div>
					)}

					{shared.length > 0 && (
						<Div m={{ b: "1rem" }}>
							<Text textSize="body" textWeight="bold" m={{ b: "0.5rem" }}>
								Resteranno, ma senza di te
							</Text>
							{shared.map(school => (
								<Text
									key={school.schoolID}
									textSize="body"
									textColor={theme.colors.text_light}>
									• {school.schoolName}
									{school.heirName
										? `, che passa a ${school.heirName}`
										: ", dove insegnano anche altri"}
								</Text>
							))}
						</Div>
					)}

					{summary && (
						<Text textSize="caption" textColor={theme.colors.text_light} m={{ b: "1rem" }}>
							Verranno eliminati anche il tuo profilo, il collegamento a Google
							Calendar e il tuo accesso.
						</Text>
					)}
				</Container>
			</Div>

			<Container>
				<Text textSize="body" m={{ t: "0.5rem", b: "0.5rem" }}>
					Scrivi <Text tag="span" textWeight="bold">{DELETE_WORD}</Text> per confermare
				</Text>
				<TextInput
					value={confirmation}
					textTransform="uppercase"
					handleChange={e => setConfirmation(e.target.value)}
				/>
			</Container>

			<ConfirmButtons
				confirmText="Elimina tutto"
				busy={isDeleting}
				busyText="Elimino..."
				disabled={!summary || confirmation.trim().toUpperCase() !== DELETE_WORD}
				onConfirm={handleDelete}
				cancelText="No, lo tengo"
				onCancel={closeModal}
			/>
		</Container>
	)
}

export default DeleteAccountModal
